module.exports = __webpack_public_path__ + "static/img/jk01.30405dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jk01.png
// module id = Sb8o
// module chunks = 0